// NPM
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Slider from "react-slick";

// TOAST
import { toaster } from 'Helpers/index';

// ANT COMPONENT
import { Card, Col, Row } from 'antd';
import {
    Avatar
} from '@life-line-lab/components-react';
import { CopyOutlined } from '@ant-design/icons';

// STYLE
import './seller.scss';
import './../voucher-list.scss';

import 'moment/locale/ms';

interface VoucherListSellerComponentProps {
    voucherList: any;
    hideTitle: boolean;
}

const VoucherListSellerComponent: React.FC<VoucherListSellerComponentProps> = ({voucherList, hideTitle}) => {
    
    let settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        responsive: [
            {
                breakpoint: 1650,
                settings: {
                    slidesToShow: 5,
                    infinite: voucherList.length > 5,
                    dots: true
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                    infinite: voucherList.length > 4,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    infinite: voucherList.length > 3,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    infinite: voucherList.length > 2,
                    dots: true
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    infinite: voucherList.length > 1,
                    dots: true
                }
            },
        ]
    };

    const [screenChangeBoolean, setScreenChangeBoolean] = useState(true);

    const { t, i18n } = useTranslation();

    // ADD TEXT TO COPY CLIPBOARD
    const handleCopyToClipboard = (str: string) => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        toaster('success', t('toaster.copiedToClipboard'));
    };

    // ADD RESIZE EVENT LISTINER THAT SET BOOLEAN STATE TO TRUE WHEN SCREEN SIZE CHANGE
    useEffect(() => {
        const listener = () => setScreenChangeBoolean(true);
        window.addEventListener("resize", listener);
    }, [])

    // WHEN SCREEN WIDTH CHANGE OR LOAD FIRST TIME
    // TIMEOUT 100 TO GET WIDTH OF CONTAINER WITH CONTENT
    // LOOP THROUGH ELEMENT LIST IF EXIST AND UPDATE STYLE
    useEffect(() => {
        setTimeout(() => {
            const elements = document.getElementsByClassName("voucher");
            if (elements) {
                for (let i = 0; i < elements.length; i++) {
                    if ((elements[i] as HTMLElement).offsetWidth > 207) {
                        (document.getElementsByClassName("voucher-usage")[i] as HTMLElement).style.whiteSpace = "nowrap";
                    } else {
                        (document.getElementsByClassName("voucher-usage")[i] as HTMLElement).style.whiteSpace = "";
                    }
                }
                setScreenChangeBoolean(false);
            }
        }, 100);
    }, [screenChangeBoolean])

    const getFormattedLocaleDate = (dateString: any) => {
        if (i18n.language === 'ms') {
            moment.locale('ms');
        } else {
            moment.locale('en');
        }
        return moment(dateString).format('D MMMM YYYY')
    }

    return (
        <div className={`voucher-seller-container ${hideTitle ? '': 'px-15 py-10'}`}>
            {
                hideTitle ? null :
                <div className="voucher-title my-24 center-text">{t('label.VoucherSellerTxt')}</div>
            }
            <Slider {...settings}>
                {
                    voucherList.map((voucher, index) => {
                        return (
                            <Card className="voucher" key={index}>
                                <div className="punch-hole-left"></div>
                                <div className="punch-hole-right"></div>
                                <div className="center-text">
                                    <div>
                                        {
                                            voucher?.noOfVouchers.remaining !== 0 ?
                                                <div className="ribbon-container" >
                                                <div className="ribbon up">
                                                    {
                                                        voucher?.noOfVouchers.remaining > 5 ?
                                                            <div className="content remaining">
                                                                {t('label.OnlyLeft', { count: voucher.noOfVouchers.remaining })}
                                                            </div>
                                                            :
                                                            <div className="content remaining">
                                                                {t('label.AlmostGone')}
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                            : null
                                        }
                                        <Avatar className="avatar" size="large" src={voucher.orgImage?.file_url} />
                                        <div className="mt-10 voucher-name">{voucher.orgName}</div>
                                        <div className="mt-15 voucher-amount">
                                            {
                                                    voucher.discountType === "FIAT" ?
                                                        `RM${voucher.discountValue} ${t('label.AmountOff')}`
                                                        : `${voucher.discountValue}% ${t('label.AmountOff')}`
                                            }
                                        </div>
                                        <div className="voucher-type">{t(`voucher.${voucher.voucherType}`)}</div>
                                        <div className="voucher-min">{t('label.MinSpend')} RM{voucher.minAmount ? voucher.minAmount : 0}</div>
                                        {
                                            voucher?.capValue ?
                                                <div className="voucher-cap">{t('label.CappedAt')} RM{voucher.capValue}</div>
                                                : null
                                        }
                                    </div>
                                    <div className="fixed-bottom">
                                        {
                                            voucher?.noOfVouchers.remaining === 0 ?
                                                <div className="redeemed mb-15">
                                                    {t('label.FullyRedeemed')}
                                                </div>
                                                :
                                                <div>
                                                {voucher?.voucherCode ?
                                                    <div className="chip">
                                                        {voucher.voucherCode}
                                                        <CopyOutlined onClick={() => handleCopyToClipboard(voucher?.voucherCode)} className="copy-icon" />
                                                    </div>
                                                    :
                                                    <div className="chip no-code">
                                                        {t('label.NoCodeRequired')}
                                                    </div>
                                                }
                                                <div className="mt-10 voucher-usage">
                                                    {t('label.UseBy')} {getFormattedLocaleDate(voucher.validTo)}.
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Card>
                        )
                    })
                }
            </Slider>
        </div>
    )
}

export default VoucherListSellerComponent;
